var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseIconUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 10,
    viewBox: "0 0 18 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1758 7.73415C17.6082 8.13767 17.6081 8.80781 17.1755 9.21118C16.7627 9.59606 16.1062 9.59606 15.6935 9.21118L9 2.96967L2.30651 9.21119C1.89376 9.59606 1.23727 9.59606 0.824525 9.21119C0.615066 9.01587 0.499999 8.75578 0.499999 8.47251C0.499999 8.1893 0.61502 7.92926 0.824399 7.73395L8.25867 0.788816C8.67142 0.40394 9.32825 0.403625 9.74099 0.7885L17.1758 7.73415Z",
    fill: "#2B2B2B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIconUp);
export default __webpack_public_path__ + "static/media/close-icon-up.0078e1e8.svg";
export { ForwardRef as ReactComponent };